import { inject, Injectable } from '@angular/core';
import {
  JobTypeServiceCreateRequest,
  JobTypeServiceCreateResponse,
  JobTypeServiceCreateResponseSchema,
  JobTypeServiceGetResponseSchema,
  JobTypeServiceListRequest,
  JobTypeServiceUpdateRequest,
  JobTypeServiceUpdateResponseSchema,
} from '@vmspdb/definitions';
import { ConnectJobType } from '@vmspdb/ui/connect';
import { ApiPaginated } from '@vmspdb/ui/domain';
import { map, Observable } from 'rxjs';
import { ApiRepositoryService } from './api-repository.service';
import { reencode } from './reencode';

@Injectable({
  providedIn: 'root',
})
export class JobTypeRepositoryService implements ApiRepositoryService<
  JobTypeServiceCreateRequest,
  JobTypeServiceUpdateRequest,
  JobTypeServiceListRequest,
  JobTypeServiceCreateResponse
> {
  private api = inject(ConnectJobType);

  create(
    data: JobTypeServiceCreateRequest,
  ): Observable<JobTypeServiceCreateResponse> {
    return this.api.create(data).pipe();
  }

  delete(uuid: string): Observable<void> {
    return this.api.delete({ uuid }).pipe(
      map(() => {
        return;
      }),
    );
  }

  fetch(uuid: string): Observable<JobTypeServiceCreateResponse> {
    return this.api
      .get({ uuid })
      .pipe(
        map((res) =>
          reencode(
            JobTypeServiceGetResponseSchema,
            JobTypeServiceCreateResponseSchema,
            res,
          ),
        ),
      );
  }

  list(
    request: JobTypeServiceListRequest,
  ): Observable<ApiPaginated<JobTypeServiceCreateResponse>> {
    return this.api.list(request);
  }

  update(
    data: JobTypeServiceUpdateRequest,
  ): Observable<JobTypeServiceCreateResponse> {
    return this.api
      .update(data)
      .pipe(
        map((res) =>
          reencode(
            JobTypeServiceUpdateResponseSchema,
            JobTypeServiceCreateResponseSchema,
            res,
          ),
        ),
      );
  }
}
